import { Link } from "react-router-dom";

export default function Breadcrumbs({ items, className = "" }) {
  const trail = [{ name: "Home", path: "/" }, ...items];
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={`py-8 ${className}`}>
      <ol className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-bold uppercase tracking-[0.14em] text-muted">
        {trail.map((it, i) => {
          const last = i === trail.length - 1;
          return (
            <li key={it.path} className="flex items-center gap-3">
              {last ? (
                <span aria-current="page" className="text-ink" data-testid="breadcrumb-current">
                  {it.name}
                </span>
              ) : (
                <Link to={it.path} data-testid={it.testId} className="transition-colors hover:text-accent">
                  {it.name}
                </Link>
              )}
              {!last && <span aria-hidden="true" className="text-line">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
